// LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

//IMG
import presentationImg from "../../../public/assets/images/inHome/camaiore.jpg";


const Presentation: React.FC = () => {
    const { t } = useTranslation();

    return(
        <section id="presentation" className="space-ptb bg-primary">
            <div className="container-fluid w-80">
                <div className="row align-items-center justify-content-center">
                    <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                        <p className="mb-2 sub-title">{t('homePage.presentation.subTitle')}</p>
                        <h2 className="mb-3">{t('homePage.presentation.title')}</h2>
                        <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.text1') as string }}></p>
                        <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.text2') as string }}></p>
                        <Link to={'/chi-siamo'} className="btn btn-primary">
                            <span>{t('homePage.presentation.btnText')}</span>    
                        </Link>
                    </div>
                    <div className="col-12 col-lg-6">
                        <img src={presentationImg} className="img-fluid border-img" alt={`${t('homePage.presentation.imgAlt1')}`}/>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;